import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ANNUAL_LEAVES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_ANNUAL_LEAVE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_ANNUAL_LEAVE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_ANNUAL_LEAVE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_ANNUAL_LEAVE:
      return _.omit(state, action.payload);
    case type.SEND_EMAIL_LEAVE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
